module.exports = __webpack_public_path__ + "static/media/more.4828e8f3.svg";